import {loadForos} from "../modulos/foros/foros";
import glossary from "../modulos/glossary/glossary";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";

export const loadForum = () => {
    console.log('Loading forum components');

    //Módulo de foros
    loadForos();

    //Módulo de glosario
    glossary();

    //Módulo de análisis más vistos
    analisisMasVistos();
}